import { FieldNames } from '@/constants/FieldNames';
import ICompData from './ICompData';

export default {
    isAddressField(compData: ICompData): boolean {
        switch (compData.fieldName) {
            case FieldNames.Address1:
            case FieldNames.Address2:
            case FieldNames.UnitNo:
            case FieldNames.City:
            case FieldNames.State:
            case FieldNames.ZipCode:
                return true;
        }
        return false;
    },
};
